import { gql } from "@apollo/client";

export const MY_DOWNLOADS_QUERY = gql`
  query MyDownloads($portalUserId: Int!) {
  myIsos(portalUserId: $portalUserId) {
  id
  product_id
  product_name
  model_num
  path
  arch
  label
  version
  size
}

  }
`;